module.exports = __webpack_public_path__ + "static/media/DocumentationIcon.5865326f.svg";